const getTableLoadIntro = () => {
    return `
    const TableRowLoading = (props) => {
    const { headCells, idx } = props;

    const TableLoading = React.memo((props) => {
    const { isLoading, headCells, numRows } = props;
    `;
}

export default getTableLoadIntro;
